export default "__VITE_ASSET__DWLG$1uL__"